/**
 * Conversioni tra ciò che l'operatore scrive e ciò che va al backend.
 *
 * Le percentuali nel database sono FRAZIONI (0.06 = 6%). In interfaccia si
 * scrivono come percentuali, e la conversione avviene solo qui.
 */

const DECIMAL_RE = /^\d+([.,]\d+)?$/;

/** "6" o "6,5" -> "0.06" / "0.065". Stringa vuota o non valida -> null. */
export function pctToFraction(input: string): string | null {
  const v = input.trim().replace(",", ".");
  if (!DECIMAL_RE.test(v)) return null;
  return String(Math.round((Number(v) / 100) * 1_000_000) / 1_000_000);
}

/** "0.060000" -> "6". */
export function fractionToPct(fraction: string | null | undefined): string {
  if (fraction === null || fraction === undefined || fraction === "") return "";
  return String(Math.round(Number(fraction) * 100 * 10_000) / 10_000);
}

/** Numero decimale scritto dall'operatore, con la virgola o col punto. */
export function decimalInput(input: string): string | null {
  const v = input.trim().replace(",", ".");
  return DECIMAL_RE.test(v) ? v : null;
}

export function intInput(input: string): number | null {
  const v = input.trim();
  return /^\d+$/.test(v) ? Number(v) : null;
}
